import React from "react";
import PropTypes from "prop-types";
const DesignSizeIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || "var(--color-easil-gray-x-dark)"}
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <polygon points="0 0 24 0 24 24 0 24" />
      <g
        transform="translate(2, 2)"
        fill={color || "var(--color-easil-gray-x-dark)"}
        fillRule="nonzero"
      >
        <path d="M14.7,18 L17,18 C17.5522847,18 18,17.5522847 18,17 L18,11 C18,10.4477153 17.5522847,10 17,10 L16.078,10 L16.078,8 L17,8 C18.6568542,8 20,9.34314575 20,11 L20,17 C20,18.6568542 18.6568542,20 17,20 L14.425,20 L14.701,18 L14.7,18 Z M14.7,18 L17,18 C17.5522847,18 18,17.5522847 18,17 L18,11 C18,10.4477153 17.5522847,10 17,10 L16.078,10 L16.078,8 L17,8 C18.6568542,8 20,9.34314575 20,11 L20,17 C20,18.6568542 18.6568542,20 17,20 L14.425,20 L14.701,18 L14.7,18 Z" />
        <path d="M9.729,18 L14,18 C14.5522847,18 15,17.5522847 15,17 L15,7 C15,6.44771525 14.5522847,6 14,6 L12.972,6 L12.972,4 L14,4 C15.6568542,4 17,5.34314575 17,7 L17,17 C17,18.6568542 15.6568542,20 14,20 L9.266,20 L9.729,18 Z M9.729,18 L14,18 C14.5522847,18 15,17.5522847 15,17 L15,7 C15,6.44771525 14.5522847,6 14,6 L12.972,6 L12.972,4 L14,4 C15.6568542,4 17,5.34314575 17,7 L17,17 C17,18.6568542 15.6568542,20 14,20 L9.266,20 L9.729,18 Z" />
        <path d="M3,2 C2.44771525,2 2,2.44771525 2,3 L2,17 C2,17.5522847 2.44771525,18 3,18 L11,18 C11.5522847,18 12,17.5522847 12,17 L12,3 C12,2.44771525 11.5522847,2 11,2 L3,2 Z M3,0 L11,0 C12.6568542,0 14,1.34314575 14,3 L14,17 C14,18.6568542 12.6568542,20 11,20 L3,20 C1.34314575,20 0,18.6568542 0,17 L0,3 C0,1.34314575 1.34314575,0 3,0 Z" />
        <path d="M5,8 L9,8 L5,8 Z M5,7 L9,7 C9.55228475,7 10,7.44771525 10,8 C10,8.55228475 9.55228475,9 9,9 L5,9 C4.44771525,9 4,8.55228475 4,8 C4,7.44771525 4.44771525,7 5,7 Z M5,12 L6,12 L5,12 Z M5,11 L6,11 C6.55228475,11 7,11.4477153 7,12 C7,12.5522847 6.55228475,13 6,13 L5,13 C4.44771525,13 4,12.5522847 4,12 C4,11.4477153 4.44771525,11 5,11 Z" />
      </g>
    </g>
  </svg>
);
DesignSizeIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default DesignSizeIcon;
